import { useTranslation } from 'react-i18next';

export default function NpsThankYouStep() {
  const { t } = useTranslation();

  return (
    <div className="w-full py-1.5 text-center">
      <h2 className="text-lg font-medium md:text-2xl">{t('NPS_THANK_YOU')}</h2>
    </div>
  );
}
